import mapValues from "lodash-es/mapValues";

enum PATHS {
  CDN_IMAGES = "IMAGES/",
  CITY_AUTOCOMPLETE = "HAPI/search/v2/villa",
  SEARCH_VILLAGE_SLUG = "HAPI/geo/v1/villages/slug/{slug}",
  SEARCH_STATE_SLUG = "HAPI/geo/v1/states/slug/{slug}",
  SEARCH_CITY_SLUG = "HAPI/geo/v1/cities/slug/{slug}",
  SEARCH_AREA_SLUG = "HAPI/geo/v1/areas/slug/{slug}",
  SEARCH_CATEGORY_SLUG = "HAPI/villa/listing/categories/{slug}",
  VILLA_BOOKING_PAYMENT = "BOOKING/payment",
  CREATE_BOOK = "BOOKING/booking",
  VILLA_PROPERTY_PRICE_FILTERS = "HAPI/villa/listing/conf/{locationType}/{slug}",
  VILLA_PROPERTY_DYNAMIC_FILTERS = "HAPI/villa/listing/filters",
  GET_VILLA_SHOPPING = "BOOKING/booking/{shoppingId}/{publicKey}",
  GET_PROPERTY = "HAPI/property/v1/properties/{propertyId}",
  VILLA_SHOPPING_CONFIRM_INFO = "BOOKING/booking/{shoppingId}/{publicKey}/confirm-info",
  VILLA_SHOPPING_CONFIRM = "BOOKING/booking/{shoppingId}/{publicKey}/confirm",
  VILLA_SEARCH_LOCATION = "HAPI/villa/listing/search/location/v2/{locationType}/{cityTitle}",
  VILLA_ROOM_PRICE = "HAPI/villa/listing/room/{roomId}/price",
  VILLA_GET_ROOM_INFO = "HAPI/villa/listing/rooms/{id}",
  GET_BANNERS = "PLATFORM/banners/banner/active",
  GET_PASSENGERS = "PLATFORMAPI/passengers/v1/passengers",
  HOTEL_REVIEW = "HAPI/hotel/review/v2/reviews/{hotelId}",
  HOTEL_REVIEW_USEFULNESS = "HAPI/hotel/review/v2/reviews/{reviewId}/helpful",
  HOTEL_RATE = "HAPI/hotel/review/v2/ratings/{hotelId}",
  HOTEL_CALENDAR = "HAPI/villa/listing/rooms/{roomId}/calendar",
  GET_HOST_REQUEST = "BOOKING/host/booking/{shoppingId}/{publicKey}",
  HOST_REQESUT_CONFIRM = "BOOKING/host/booking/{shoppingId}/{publicKey}/availability/confirm",
  HOST_REQUEST_REJECT = "BOOKING/host/booking/{shoppingId}/{publicKey}/availability/reject",
  VILLA_SEARCH_NEARBY = "HAPI/villa/listing/search/nearby",
  VILLA_GEO_NEAREST = "HAPI/geo/v1/nearest",
  INSTALMENT_WALLET = "HAPI/hotel/api/v2/instalment/wallet"
}

export const ENDPOINTS = mapValues(PATHS, (url: string) =>
  url.replace(/^.+?(\/)/, (matched) => {
    const baseURLs = {
      API2: process.env["NEXT_PUBLIC_BASE_URL_API2"],
      HAPI: process.env["NEXT_PUBLIC_BASE_URL_HAPI"],
      PLATFORM: process.env["NEXT_PUBLIC_BASE_URL_PLATFORM"],
      PLATFORMAPI: process.env["NEXT_PUBLIC_BASE_URL_PROFILE_API"],
      PROFILE: process.env["NEXT_PUBLIC_BASE_URL_PROFILE"],
      IMAGES: process.env["NEXT_PUBLIC_BASE_URL_IMAGES"],
      BOOKING: process.env["NEXT_PUBLIC_BASE_URL_BOOKING"]
    };
    const baseURL = matched.replaceAll(/\/+/g, "") as keyof typeof baseURLs;
    return `${baseURLs[baseURL]}/`;
  })
) as unknown as typeof PATHS;
